import {inject, Injectable} from '@angular/core';
import {filter} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private router: Router = inject(Router);

  constructor() {
    this.initScrollReset('main-content');
  }

  initScrollReset(elementId: string) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const contentContainer = document.getElementById(elementId);
      if (contentContainer) {
        contentContainer.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
    });
  }
}
